// extracted by mini-css-extract-plugin
module.exports = {"ariaLive":"src-js-sign-components-common-use-aria-live-module__ariaLive--11X1f"};